"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
// Polyfill for Event.path in IE 11: https://stackoverflow.com/a/46093727
function getParents(node, memo) {
  var parsedMemo = memo || [];
  var parentNode = node.parentNode;


  if (!parentNode) {
    return parsedMemo;
  }

  return getParents(parentNode, parsedMemo.concat(parentNode));
}

// Click-outside by BosNaufal: https://github.com/BosNaufal/vue-click-outside
exports.default = {
  bind: function bind(el, binding, vNode) {
    // Provided expression must evaluate to a function.
    if (typeof binding.value !== "function") {
      var compName = vNode.context.name;
      var warn = "[Vue-click-outside:] provided expression " + binding.expression + " is not a function, but has to be";
      if (compName) {
        warn += "Found in component " + compName;
      }
      console.warn(warn);
    }
    // Define Handler and cache it on the element
    var bubble = binding.modifiers.bubble;

    var handler = function handler(e) {
      // Fall back to composedPath if e.path is undefined
      var path = e.path || (e.composedPath ? e.composedPath() : false) || getParents(e.target);
      if (bubble || path.length && !el.contains(path[0]) && el !== path[0]) {
        binding.value(e);
      }
    };
    el.__vueClickOutside__ = handler;
    // add Event Listeners
    document.addEventListener("click", handler);
  },
  unbind: function unbind(el) {
    // Remove Event Listeners
    document.removeEventListener("click", el.__vueClickOutside__);
    el.__vueClickOutside__ = null;
  }
};


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/components/elements/TelInput/click-outside.js
// module id = FT5C
// module chunks = 0 1